import { useState } from 'react';
import { supabase } from '../lib/supabase';

export function useAvatarUpload(userId: string | undefined, onSuccess: () => Promise<void>) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const uploadAvatar = async (file: File) => {
    if (!userId) return;
    setUploading(true);
    setError('');
    try {
      const ext = file.name.split('.').pop() ?? 'jpg';
      const path = `${userId}/avatar-${Date.now()}.${ext}`;
      const { error: uploadError } = await supabase.storage
        .from('avatars')
        .upload(path, file, { upsert: true, contentType: file.type });
      if (uploadError) throw uploadError;

      const { data: urlData } = supabase.storage.from('avatars').getPublicUrl(path);
      const publicUrl = urlData.publicUrl;

      const { error: updateError } = await supabase
        .from('profiles')
        .update({ avatar_url: publicUrl, updated_at: new Date().toISOString() })
        .eq('id', userId);
      if (updateError) throw updateError;

      await onSuccess();
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Erro ao enviar foto';
      setError(msg);
    } finally {
      setUploading(false);
    }
  };

  const removeAvatar = async () => {
    if (!userId) return;
    setUploading(true);
    setError('');
    try {
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ avatar_url: null, updated_at: new Date().toISOString() })
        .eq('id', userId);
      if (updateError) throw updateError;
      await onSuccess();
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Erro ao remover foto';
      setError(msg);
    } finally {
      setUploading(false);
    }
  };

  return { uploadAvatar, removeAvatar, uploading, error };
}
